import{useState as o}from"react";import t from"./components/ButtonToggle.js";function r(r,n){const[e,m]=o(!1);return[t(e,m,n),e,m]}export{r as default};
